import axios from 'axios'
import { getUserToken } from '@/functions.js'
import { getServerApi } from '../../config/deployment';

const PROPERTY_CALENDAR_API_URL = `${getServerApi()}/api/property-calendar`;
const ENTRIES_ENDPOINT = 'entries';
const CHECK_AVAILABILITY_ENDPOINT = 'check-availability';

export default {
    getEntries: async ({ status = undefined, propertyId = undefined } = {}) => {
        // const token = await getUserToken();

        return await axios.get(
            `${PROPERTY_CALENDAR_API_URL}/${ENTRIES_ENDPOINT}`,
            {
                params: {
                    // token,
                    status,
                    propertyId,
                },
            }
        );
    },
    getEntry: async ({ entryId }) => {
        // const token = await getUserToken();

        return await axios.get(
            `${PROPERTY_CALENDAR_API_URL}/${ENTRIES_ENDPOINT}/${entryId}`,
            {
                // params: { token },
            }
        );
    },
    createEntry: async ({ data }) => {
        // const token = await getUserToken();

        return await axios.post(
            `${PROPERTY_CALENDAR_API_URL}/${ENTRIES_ENDPOINT}`,
            data,
            {
                // params: { token },
            }
        );
    },
    updateEntry: async ({ entryId, data }) => {
        // const token = await getUserToken();

        return await axios.put(
            `${PROPERTY_CALENDAR_API_URL}/${ENTRIES_ENDPOINT}/${entryId}`,
            data,
            {
                // params: { token },
            }
        );
    },
    deleteEntry: async (entryId) => {
        // const token = await getUserToken();

        return await axios.delete(
            `${PROPERTY_CALENDAR_API_URL}/${ENTRIES_ENDPOINT}/${entryId}`,
            {
                // params: { token },
            }
        );
    },
    checkAvailability: async ({ propertyId, exceptEntries = [], startDate, endDate }) => {
        // const token = await getUserToken();

        return await axios.post(
            `${PROPERTY_CALENDAR_API_URL}/${ENTRIES_ENDPOINT}/${CHECK_AVAILABILITY_ENDPOINT}`,
            {
                propertyId,
                startDate,
                endDate,
                exceptEntries,
            },
            {
                // params: { token },
            }
        );
    },
}



// WEBPACK FOOTER //
// ./src/services/property-calendar/index.js